import React from 'react';
import { CTAButton } from '@/components/shared/streamline/StreamlineControls';
import { useAbsoluteNavigate } from '@/hooks/useAbsoluteNavigate';
import { useIntl } from 'react-intl';

type GamesSectionHeaderProps = {
  title: string;
  categoryPath: string;
  totalGames: number;
};

function GamesSectionHeader({ title, categoryPath, totalGames }: GamesSectionHeaderProps) {
  const intl = useIntl();
  const navigate = useAbsoluteNavigate();
  const buttonOnClick = () => {
    navigate(categoryPath);
  };
  return (
    <div className="flex flex-row w-full justify-between sm:justify-start sm:w-fit border-b-2 border-blue-light gap-x-16">
      <h1
        onClick={buttonOnClick}
        className="text-xl sm:text-2xl md:text-3xl font-bold text-black m-0 px-2 py-0 hover:cursor-pointer"
      >
        {title}
      </h1>
      <CTAButton
        onClick={buttonOnClick}
        text={intl.formatMessage({ id: 'games.showAll' }) + ' (' + totalGames + ')'}
      />
    </div>
  );
}

export default GamesSectionHeader;
